const linkurlconfig = {
  trading_view_snapshot_url: `${
    process.env.REACT_APP_COMMON_SERVICE_ENDPOINT
  }/UserSetting/ExtractChartLayoutContnent

`,
  ta_signal_link_pdf: `https://market.fiintrade.vn/fiintrade.pdf`,
};

export default linkurlconfig;
